<template>
  <div class="notifications-button-wrapper" tabindex="0">
    <div class="menu-attach-element" />
    <nav-square-button class="notifications-button" :badge-count="newActivitiesCount" :active="active" :tab-index="-1">
      <template #active>
        <i-custom-inbox-filled />
      </template>
      <template #inactive>
        <i-custom-inbox />
      </template>
    </nav-square-button>
  </div>
</template>

<script>
import { mapState } from "pinia"

import { useUserSessionStore } from "@/store/userSession.js"

import NavSquareButton from "@/components/navs/NavSquareButton.vue"

import { useActivatedState } from "@/composables/useActivatedState.js"

export default {
  components: {
    NavSquareButton
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { activated } = useActivatedState()
    return { activated }
  },
  data() {
    return {
      shouldShowInboxOnReturn: false,
      menuWidth: 380,
      iconSize: 64
    }
  },
  computed: {
    ...mapState(useUserSessionStore, ["newActivitiesCount"])
  }
}
</script>

<style lang="scss" scoped>
.app-icon {
  width: 24px;
  height: 24px;
}

// Needs fixing - focusing with tab has incorrect styles
.notifications-button-wrapper {
  &:not(:focus-visible) {
    .notifications-button {
      &:not(:hover) {
        &:before {
          content: none !important;
        }
      }
    }
  }

  &:focus {
    outline: none;

    button {
      &:before {
        opacity: 0.12 !important;
        background-color: currentColor !important;
      }
    }
  }

  .notifications-button {
    &:before {
      border-bottom: none !important;
    }
  }

  .menu-attach-element {
    position: relative;
  }
}
</style>
